import { render, staticRenderFns } from "./TermoDeUsoView.vue?vue&type=template&id=1d271166"
import script from "./TermoDeUsoView.vue?vue&type=script&lang=js"
export * from "./TermoDeUsoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports